import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { useTranslation } from 'react-i18next';
import { Provider } from 'react-redux';
import { Tenant } from './app/enum/tenant';
import type { IRootState } from './app/store';
import { applicationActions, configureStore, history } from './app/store';
import { getTenant, isInitialized } from './app/store/application/application-selectors';
import { initI18n } from './i18n';

initI18n().then(() => {
    const store = configureStore({}, { history });
    const RootContainer = lazy(() => import('./app/container/root-container/root-container'));
    const root = createRoot(document.querySelector('esprit-portal') as HTMLElement);

    const Main = () => (
        <StrictMode>
            <Suspense fallback={<i />}>
                <Provider store={store}>
                    <RootContainer />
                </Provider>
            </Suspense>
        </StrictMode>
    );

    const NoTenantFallback = () => <b>{useTranslation().t('error-message.tenant-could-not-be-loaded')}</b>;

    const unsubscribe = store.subscribe(() => {
        const state: IRootState = store.getState();
        if (!isInitialized(store.getState())) {
            return;
        }
        if (getTenant(state) === Tenant.NO_TENANT) {
            root.render(<NoTenantFallback />);
        } else {
            root.render(<Main />);
        }
        unsubscribe();
    });

    store.dispatch(applicationActions.initializeApplication());
});
